// Configuration pour l'envoi d'emails via backend Express
// L'URL de l'API backend peut être configurée via REACT_APP_API_URL
// Par défaut: http://localhost:5000 en développement, /api/send-email en production
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // En développement local, utiliser le backend sur le port 5000
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000/api/send-email';
  }
  
  // En production, utiliser l'URL relative (proxy ou même domaine)
  return '/api/send-email';
};

export const emailConfig = {
  apiUrl: getApiUrl(),
  toEmail: 'fossiflorent@gmail.com'
};
